import React from 'react';
import { openSizingForm } from '../lib/sizingForm';
import SeasonalCapacityNote from './SeasonalCapacityNote';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="main-content" className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-20 pb-16 bg-white">
      <div className="container-max w-full">
        <div className="text-center max-w-5xl mx-auto">
          {/* Hero Content */}
          <div className="space-y-8">
            {/* Eyebrow text */}
            <p className="text-rebel-coral text-sm sm:text-base font-medium tracking-wide uppercase" style={{maxWidth: 'none'}}>
              Using data to make clean heat simple
            </p>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold text-rebel-dark leading-[1.1] tracking-tight">
              The Fitness Tracker for Your Heating System
            </h1>

            <p className="text-xl sm:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Proving low-temperature capability to cut install costs. Most homes can run a heat pump on their existing radiators, and your own heating data shows whether yours can.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
              <button
                onClick={openSizingForm}
                className="w-full sm:w-auto bg-rebel-coral text-white px-10 py-4 rounded-lg font-semibold text-lg hover:bg-rebel-orange transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rebel-coral min-h-[44px] touch-manipulation shadow-lg"
                aria-label="Open the free heat pump sizing form"
              >
                Join the Waitlist
              </button>
              <button
                onClick={() => scrollToSection('problem')}
                className="w-full sm:w-auto border-2 border-rebel-dark text-rebel-dark px-10 py-4 rounded-lg font-semibold text-lg hover:bg-gray-50 transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rebel-coral min-h-[44px] touch-manipulation"
                aria-label="Learn more about Rebel"
              >
                Learn More
              </button>
            </div>

            <SeasonalCapacityNote className="pt-2" />
          </div>

          {/* Scroll indicator */}
          <div className="mt-20 animate-bounce">
            <button
              onClick={() => scrollToSection('problem')}
              className="text-gray-400 hover:text-rebel-coral transition-colors duration-300 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rebel-coral rounded-full p-3 min-h-[44px] min-w-[44px] touch-manipulation"
              aria-label="Scroll to problem section"
            >
              <svg className="w-6 h-6 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;